import type { JSX } from 'react';
import type { Product } from '@/types/Product.types';
import styles from '../ApprovalPortalPage.module.css';
import { ProductCard } from './ProductCard';

interface ProductsGridProps {
  products: Product[];
}

export const ProductsGrid = ({ products }: ProductsGridProps): JSX.Element => (
  <div className={styles.productsCard}>
    <div className={styles.productsHeader}>
      <span className={styles.productsLabel}>Products</span>
      <span className={styles.productsCountBadge}>{products.length}</span>
    </div>
    {products.length > 0 ? (
      <div className={styles.productsGrid}>
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    ) : (
      <p className={styles.noProducts}>No products linked to this post.</p>
    )}
  </div>
);
